import * as React from 'react'
import './Pagination.css'

const PER_PAGE_OPTIONS = [10, 25, 50]

interface Props {
  page: number
  totalPages: number
  total: number
  perPage: number
  onPage: (p: number) => void
  onPerPage: (n: number) => void
}

export function Pagination({ page, totalPages, total, perPage, onPage, onPerPage }: Props): React.JSX.Element | null {
  if (total === 0) return null

  const start = (page - 1) * perPage + 1
  const end = Math.min(page * perPage, total)

  return (
    <div className="pagination">
      <span className="pagination-info">
        {start}–{end} of {total}
      </span>
      <div className="pagination-right">
        <label className="pagination-label">
          Rows
          <select
            className="select pagination-select"
            value={perPage}
            onChange={(e) => { onPerPage(Number(e.target.value)) }}
          >
            {PER_PAGE_OPTIONS.map((n) => (
              <option key={n} value={n}>{n}</option>
            ))}
          </select>
        </label>
        <div className="pagination-btns">
          <button className="pagination-btn" disabled={page <= 1} onClick={() => onPage(1)} aria-label="First">«</button>
          <button className="pagination-btn" disabled={page <= 1} onClick={() => onPage(page - 1)} aria-label="Previous">‹</button>
          <span className="pagination-current">{page} / {totalPages}</span>
          <button className="pagination-btn" disabled={page >= totalPages} onClick={() => onPage(page + 1)} aria-label="Next">›</button>
          <button className="pagination-btn" disabled={page >= totalPages} onClick={() => onPage(totalPages)} aria-label="Last">»</button>
        </div>
      </div>
    </div>
  )
}
